// error-highlighter.ts
import { StateEffect, StateField } from '@codemirror/state';
import {
  Decoration,
  DecorationSet,
  EditorView,
  WidgetType,
} from '@codemirror/view';

class ErrorWidget extends WidgetType {
  constructor(private message: string) {
    super();
  }

  toDOM(): HTMLElement {
    const el = document.createElement('div');
    el.className = 'cm-inline-error';
    el.textContent = this.message;
    return el;
  }

  ignoreEvent(): boolean {
    return true;
  }
}
export const setErrorEffect = StateEffect.define<{
  line: number;
  message: string;
  column: number;
} | null>();

export const errorHighlightField = StateField.define<DecorationSet>({
  create: () => Decoration.none,

  update(deco, tr) {
    for (const effect of tr.effects) {
      if (effect.is(setErrorEffect)) {
        if (!effect.value) return Decoration.none;

        const { line, message, column } = effect.value;
        const lineInfo = tr.state.doc.line(line);

        const highlight = Decoration.line({
          class: 'cm-error-line',
        }).range(lineInfo.from);

        const fullMessage = `Error on line: ${line}, column: ${column}: ${message}`;

        const widget = Decoration.widget({
          widget: new ErrorWidget(fullMessage),
          side: 1,
        }).range(lineInfo.to);

        return Decoration.set([highlight, widget]);
      }
    }

    return deco.map(tr.changes);
  },

  provide: (f) => EditorView.decorations.from(f),
});
